
export enum MessageHubActionType {
    SubscribeToGroup = 'SubscribeToGroup',
    UnSubscribeFromGroup = 'UnSubscribeFromGroup'
}
